/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BytesLike,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  AccessControlSegregator,
  AccessControlSegregatorInterface,
} from "../AccessControlSegregator";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes4[]",
        name: "functions",
        type: "bytes4[]",
      },
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "GRANT_ACCESS_SIG",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    name: "functionAccess",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "sig",
        type: "bytes4",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasAccess",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "sig",
        type: "bytes4",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantAccess",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type AccessControlSegregatorConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: AccessControlSegregatorConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class AccessControlSegregator__factory extends ContractFactory {
  constructor(...args: AccessControlSegregatorConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "AccessControlSegregator";
  }

  deploy(
    functions: BytesLike[],
    accounts: string[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<AccessControlSegregator> {
    return super.deploy(
      functions,
      accounts,
      overrides || {}
    ) as Promise<AccessControlSegregator>;
  }
  getDeployTransaction(
    functions: BytesLike[],
    accounts: string[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(functions, accounts, overrides || {});
  }
  attach(address: string): AccessControlSegregator {
    return super.attach(address) as AccessControlSegregator;
  }
  connect(signer: Signer): AccessControlSegregator__factory {
    return super.connect(signer) as AccessControlSegregator__factory;
  }
  static readonly contractName: "AccessControlSegregator";
  public readonly contractName: "AccessControlSegregator";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): AccessControlSegregatorInterface {
    return new utils.Interface(_abi) as AccessControlSegregatorInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): AccessControlSegregator {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as AccessControlSegregator;
  }
}
